var Cachable = /*@__PURE__*/ (function () {
    function Cachable() {
    }
    Cachable.prototype.toJSON = function () {
        return {
            expires: this.expires,
            data: this.data
        };
    };
    return Cachable;
}());
export { Cachable };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/core/storage/cachable.ts
// module id = null
// module chunks = 